/**
 * THE EVENT WINDOW
 * ----------------
 * Used only to label and group things by event day (the schedule, the gallery,
 * the home page). Nothing reads the clock to decide a match's status: status is
 * whatever staff last set.
 */

/** Day 1, first whistle. */
export const EVENT_START = new Date('2026-09-24T09:00:00+05:30');
export const EVENT_DAYS = 4;

export const EVENT_DATE_RANGE_LABEL = '24–27 September 2026';

/** Start of event day `n` (1-based) at 09:00. */
export function eventDayStart(day: number): Date {
  const d = new Date(EVENT_START);
  d.setDate(d.getDate() + (day - 1));
  return d;
}

/** The event's clock: every date is read in India time, whatever the viewer's timezone. */
const EVENT_OFFSET_MS = 330 * 60_000; // +05:30

/**
 * The India-time calendar date of an instant, as YYYY-MM-DD. The database sends
 * times in UTC, so slicing its string would put anything before 05:30 IST on
 * the previous day.
 */
export function eventDateKey(iso: string): string {
  return new Date(new Date(iso).getTime() + EVENT_OFFSET_MS).toISOString().slice(0, 10);
}

/**
 * Which event day (1-based) a given instant falls on, by India-time calendar
 * date (midnight to midnight, not from the 09:00 first whistle); 0 if outside the event.
 */
export function eventDayOf(iso: string): number {
  const day = Math.round(
    (Date.parse(eventDateKey(iso)) - Date.parse(eventDateKey(EVENT_START.toISOString()))) / (24 * 3600_000),
  ) + 1;
  return day >= 1 && day <= EVENT_DAYS ? day : 0;
}
